/* abudashop – movimento: comparse allo scroll, contatori, slider modelli, manifesto */
(function () {
  if (window.abMotion) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(pointer: fine)');
  document.documentElement.classList.add('ab-js');

  /* ---------- Comparse ---------- */
  var revealIO =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              revealIO.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  function reveal(root) {
    (root || document).querySelectorAll('[data-ab-reveal]:not(.is-in)').forEach(function (el) {
      if (!revealIO || reduce.matches) {
        el.classList.add('is-in');
        return;
      }
      revealIO.observe(el);
    });
  }

  /* ---------- Contatori ---------- */
  var nf = new Intl.NumberFormat(document.documentElement.lang || 'it-IT');

  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-ab-count'));
    if (isNaN(target)) return;
    if (reduce.matches) {
      el.textContent = nf.format(target);
      return;
    }
    var start = null;
    var duration = 1400;
    function tick(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = nf.format(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var countIO =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              runCounter(entry.target);
              countIO.unobserve(entry.target);
            });
          },
          { threshold: 0.6 }
        )
      : null;

  function counters(root) {
    (root || document).querySelectorAll('[data-ab-count]').forEach(function (el) {
      if (el.dataset.abCounted) return;
      el.dataset.abCounted = '1';
      if (!countIO) {
        runCounter(el);
        return;
      }
      if (!reduce.matches) el.textContent = '0';
      countIO.observe(el);
    });
  }

  /* ---------- Slider modelli ---------- */
  class AbRail extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;

      var self = this;
      var isRtl = function () {
        return getComputedStyle(self).direction === 'rtl';
      };
      var step = function () {
        var card = self.track.querySelector('[data-card]');
        var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
        var w = card ? card.getBoundingClientRect().width + gap : self.track.clientWidth * 0.8;
        var visible = Math.max(1, Math.floor((self.track.clientWidth + gap) / w));
        return w * visible;
      };
      var go = function (dir) {
        var delta = step() * dir * (isRtl() ? -1 : 1);
        self.track.scrollBy({ left: delta, behavior: reduce.matches ? 'auto' : 'smooth' });
      };
      if (this.prev) this.prev.addEventListener('click', function () { go(-1); });
      if (this.next) this.next.addEventListener('click', function () { go(1); });

      this.track.addEventListener('scroll', function () { self.queue(); }, { passive: true });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () { self.queue(); });
        this.ro.observe(this.track);
      }
      this.setupDrag();
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    queue() {
      if (this._raf) return;
      var self = this;
      this._raf = requestAnimationFrame(function () {
        self._raf = null;
        self.update();
      });
    }

    update() {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth;
      var x = Math.abs(t.scrollLeft);
      var ratio = t.scrollWidth > 0 ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
      var p = max > 2 ? x / max : 0;
      this.style.setProperty('--ab-thumb', ratio.toFixed(4));
      this.style.setProperty('--ab-progress', p.toFixed(4));
      this.classList.toggle('is-static', max <= 2);
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;
    }

    setupDrag() {
      var t = this.track;
      var self = this;
      var startX = 0;
      var startScroll = 0;
      var moved = false;
      var dragging = false;

      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !finePointer.matches) return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startScroll = t.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          self.classList.add('is-dragging');
        }
        if (moved) t.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        self.classList.remove('is-dragging');
        if (moved) {
          var block = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          };
          t.addEventListener('click', block, { capture: true, once: true });
          setTimeout(function () { t.removeEventListener('click', block, { capture: true }); }, 50);
        }
      });
      t.addEventListener('dragstart', function (e) {
        if (dragging) e.preventDefault();
      });
    }
  }
  if (!customElements.get('ab-rail')) customElements.define('ab-rail', AbRail);

  /* ---------- Manifesto: parole che si accendono con lo scroll ---------- */
  class AbManifesto extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      if (reduce.matches) {
        this.style.setProperty('--ab-p', '1');
        return;
      }
      this.onScroll = function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () {
          self._raf = null;
          self.update();
        });
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            window.addEventListener('scroll', self.onScroll, { passive: true });
            self.update();
          } else {
            window.removeEventListener('scroll', self.onScroll);
          }
        });
        this.io.observe(this);
      } else {
        this.style.setProperty('--ab-p', '1');
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      window.removeEventListener('scroll', this.onScroll);
    }

    update() {
      var text = this.querySelector('[data-words]') || this;
      var r = text.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var start = vh * 0.88;
      var end = vh * 0.38;
      var span = r.height + (start - end);
      var p = (start - r.top) / span;
      p = Math.max(0, Math.min(1, p));
      this.style.setProperty('--ab-p', p.toFixed(4));
    }
  }
  if (!customElements.get('ab-manifesto')) customElements.define('ab-manifesto', AbManifesto);

  /* ---------- Avvio ---------- */
  function init(root) {
    reveal(root);
    counters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.abMotion = { init: init };
})();